<template>
  <div class="article-detail">
    <h2 class="article-title">{{ dataSource.articleTitle }}</h2>
    <!--    <p class="article-description">{{ dataSource.description }}</p>-->
    <div class="article-meta">
      <!--      <span class="article-category">{{ dataSource.categoryName }}</span>-->
      <span class="article-date">最后一次修改时间: {{ dataSource.updateTime }}</span>
    </div>
    <el-divider/>
    <div class="article-content" v-dompurify-html="dataSource.articleContent"></div>
  </div>
</template>

<script setup>
import { findArticleDetailByFlag } from '/composables/api/home'

const route = useRoute()
const dataSource = ref([])

// 获取文章数据的函数
const fetchArticleData = async (flag) => {
  try {
    const data = await findArticleDetailByFlag(flag)
    dataSource.value = data.data
  } catch (error) {
    console.error('获取文章数据失败:', error)
  }
}

// 初始加载
await fetchArticleData(route.params.flag)

// 监听路由变化
watch(() => route.params.flag, async (newFlag) => {
  if (newFlag) {
    await fetchArticleData(newFlag)
  }
})
</script>

<style scoped lang="less">
.article-detail {
  width: 85%;
  background: #fff;
  padding-left: 30px;
  padding-right: 30px;
}

.article-title {
  font-size: 32px;
  margin-bottom: 10px;
}

.article-description {
  margin-bottom: 20px;
  background-color: #f2f2f2;
  padding: 10px;
}

.article-meta {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.article-category {
  background-color: #f2f2f2;
  padding: 5px 10px;
  border-radius: 5px;
}

.article-date {
  color: #888;
}

.article-content {
  margin-top: 20px;
  line-height: 1.5;
}

</style>
